import { TaskListBase, WITHOUT_LIST_ID } from '@awork/features/task/models/task-list.model.base'
import type { Task } from '@awork/features/task/models/task.model'
import { FieldSize } from '../../../_shared/static-data/field-sizes'

/**
 * The task list in awork
 */
export class TaskList extends TaskListBase {
  static readonly NAME_MAX_LENGTH = FieldSize.MainEntityName

  constructor(taskList: Partial<TaskList>) {
    super(taskList)
  }

  static isTaskList(list: unknown): list is TaskList {
    return (list as TaskList)?.typeName === 'TaskList'
  }

  static getWithoutList(): TaskList {
    return new TaskList({ id: WITHOUT_LIST_ID, order: 9999 })
  }

  get type(): string {
    if (this.projectId) {
      return 'project'
    } else {
      return 'private'
    }
  }

  setOrderOfTask(tasks: Task[]): void {
    const nTasks = tasks ? tasks.length : 0

    // Set the order as the last one in the list
    // (the one before this new task that is already pushed to the array, hence `nTasks - 2`)
    if (nTasks > 1) {
      const lastTaskList = tasks[nTasks - 2].lists.find(list => list.id === this.id)

      if (lastTaskList) {
        this.orderOfTask = lastTaskList.orderOfTask + 1
      }
    } else {
      this.orderOfTask = 0
    }
  }

  /**
   * Task list name max length
   * @returns {number}
   */
  get taskListNameMaxLength(): number {
    return TaskList.NAME_MAX_LENGTH
  }
}
